/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import {
    SET_SETTINGS_MENU_FOCUS,
    SET_DEFAULT_SETTINGS_MENU_STATE,
    SET_SETTINGS_MENU_VERTICAL_POSITION,
    SET_DEFAULT_SETTINGS_SUBMENU_STATE,
    SET_SETTINGS_SUBMENU_FOCUS,
    SET_SETTINGS_SUBMENU_VERTICAL_POSITION,
    SET_SETTINGS_ENTERED_NUMBER,
    SET_SETTINGS_FOCUSED_ITEM_INDEX,
    SET_SETTINGS_MENU_SELECTED_ITEM,
    SET_SETTINGS_SUBMENU_SELECTED_ITEM,
    SET_SETTINGS_NEXT_HIGHLIGHT_POSITION,
    SET_SETTINGS_MENU_HIGHLIGHT_ITEM,
    SET_SETTINGS_HIGHLIGHT_MENU,
    SET_SETTINGS_HIGHLIGHT_SUBMENU,
} from './settings.types';

export const setIsMenuFocusedAction = (isFocused: boolean): AnyAction => ({
    type: SET_SETTINGS_MENU_FOCUS,
    payload: { isFocused },
});

export const setIsSubmenuFocusedAction = (isSubmenuFocused: boolean): AnyAction => ({
    type: SET_SETTINGS_SUBMENU_FOCUS,
    payload: { isSubmenuFocused },
});

export const setMenuVerticalPositionAction = (menuVerticalPosition: number): AnyAction => ({
    type: SET_SETTINGS_MENU_VERTICAL_POSITION,
    payload: { menuVerticalPosition },
});

export const setSubmenuVerticalPositionAction = (submenuVerticalPosition?: number): AnyAction => ({
    type: SET_SETTINGS_SUBMENU_VERTICAL_POSITION,
    payload: { submenuVerticalPosition },
});

export const setFocusedItemIndexAction = (focusedItemIndex?: number): AnyAction => ({
    type: SET_SETTINGS_FOCUSED_ITEM_INDEX,
    payload: { focusedItemIndex },
});

export const setDefaultSettingsMenuStateAction = (
    menuVerticalLimit: number,
    menuVerticalPosition: number,
    isFocused: boolean,
    focusedItemIndex: number,
): AnyAction => ({
    type: SET_DEFAULT_SETTINGS_MENU_STATE,
    payload: {
        menuVerticalLimit,
        menuVerticalPosition,
        isFocused,
        focusedItemIndex,
    },
});

export const setDefaultSettingsSubmenuStateAction = (
    submenuVertialLimit: number,
    isSubmenuFocused: boolean,
    submenuVerticalPosition?: number,
): AnyAction => ({
    type: SET_DEFAULT_SETTINGS_SUBMENU_STATE,
    payload: {
        submenuVertialLimit,
        submenuVerticalPosition,
        isSubmenuFocused,
    },
});

export const setEnteredNumberAction = (enteredNumber: string): AnyAction => ({
    type: SET_SETTINGS_ENTERED_NUMBER,
    payload: {
        enteredNumber,
    },
});

export const setMenuSelectedItem = (
    isFocused: boolean,
    focusedItemIndex: number,
    menuVerticalPosition: number,
): AnyAction => ({
    type: SET_SETTINGS_MENU_SELECTED_ITEM,
    payload: {
        isFocused,
        focusedItemIndex,
        menuVerticalPosition,
    },
});

export const setMenuHighlightItem = (
    isFocused: boolean,
    isSubmenuFocused: boolean,
    menuVerticalPosition: number,
    submenuVerticalPosition?: number,
): AnyAction => ({
    type: SET_SETTINGS_MENU_HIGHLIGHT_ITEM,
    payload: {
        isFocused,
        isSubmenuFocused,
        menuVerticalPosition,
        submenuVerticalPosition,
    },
});

export const setSubmenuSelectedItem = (
    isSubmenuFocused: boolean,
    focusedItemIndex: number,
    submenuVerticalPosition: number,
): AnyAction => ({
    type: SET_SETTINGS_SUBMENU_SELECTED_ITEM,
    payload: {
        isSubmenuFocused,
        focusedItemIndex,
        submenuVerticalPosition,
    },
});

export const setNextHighlightPosition = (
    focusedItemIndex: number,
    isFocused: boolean,
    isSubmenuFocused: boolean,
): AnyAction => ({
    type: SET_SETTINGS_NEXT_HIGHLIGHT_POSITION,
    payload: {
        focusedItemIndex,
        isFocused,
        isSubmenuFocused,
    },
});

export const setMenuHighlightAction = (
    isFocused: boolean,
    focusedItemIndex?: number,
): AnyAction => ({
    type: SET_SETTINGS_HIGHLIGHT_MENU,
    payload: {
        focusedItemIndex,
        isFocused,
    },
});

export const setSubmenuHighlightAction = (
    isSubmenuFocused: boolean,
    focusedItemIndex?: number,
): AnyAction => ({
    type: SET_SETTINGS_HIGHLIGHT_SUBMENU,
    payload: {
        focusedItemIndex,
        isSubmenuFocused,
    },
});
